import React, { Component } from 'react';
import '../../../node_modules/rc-rate/assets/index.css';
import view from '../../resources/images/estrategas/tools/view.svg';


class ViewSummaryFiles extends Component {

  constructor(props) {
    super(props);
    this.viewReport = this.viewReport.bind(this);
  }

  viewReport() {
    window.open(this.props.url);
  }

  render() {
    return (
      <div className='view-summary-files'>
        <img src={view} title="Ver" alt=" " onClick={this.viewReport}/>
      </div>
    );
  }
}

export default ViewSummaryFiles;



// WEBPACK FOOTER //
// ./src/components/buttons/viewSummaryFiles.js